import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLang } from "../utils/LangContext";
import dayjs from "dayjs";
import localStorageHelper from "../utils/localStorageHelper";

const LangChange = () => {
  const { t, changeLanguage } = useLang(); // Access translation and language change functions from context

  const languages = [
    { code: "en", label: t("eng"), code_long: "eng" },
    { code: "et", label: t("est"), code_long: "est" },
    { code: "ru", label: t("rus"), code_long: "rus" },
  ];

  // Load selected language from localStorage, fallback to "en"
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const storedLangCode = localStorageHelper.getItem('currentLang') || "en";
    return languages.find(language => language.code === storedLangCode) || languages[0];
  });

  useEffect(() => {
    dayjs.locale(selectedLanguage.code); // Update dayjs locale
  }, [selectedLanguage]);

  const onLanguageChange = (langCode) => {
    changeLanguage(langCode); // Update language globally
    dayjs.locale(langCode); // Update dayjs locale

    const chosenLang = languages.find(language => language.code === langCode);
    if (chosenLang) {
      setSelectedLanguage(chosenLang);
      localStorageHelper.setItem("currentLang", langCode); // Save only the language code
    }
  };

  return (
    <div id="langChange">
      <Dropdown>
        <Dropdown.Toggle className="langChange" id="dropdown-basic">
          {selectedLanguage.label} <FontAwesomeIcon icon={["fas", "globe"]} size="1x" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="langChangeDrop">
          {languages.map((lang) => (
            <Dropdown.Item
              key={lang.code}
              className="langChangeElm"
              onClick={() => onLanguageChange(lang.code)}
            >
              {lang.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LangChange;
